import React from "react";
import { Container, Box, Card, CardContent, Typography, Stack, Button } from "@mui/material";
import { EmailOutlined } from "@mui/icons-material";

const ContactSupportPage: React.FC = () => {
  return (
    <Container sx={{ mt: { xs: 4, md: 6 }, display: "flex", justifyContent: "center" }}>
      <Box sx={{ maxWidth: 520, width: "100%" }}>
        <Typography variant="body1" align="center" color="text.secondary" sx={{ mb: 3 }}>
          Contact Scheduify support for help with your account, website, or bookings.
        </Typography>

        <Stack spacing={2}>
            <Card elevation={2} sx={{ borderRadius: 2 }}>
              <CardContent sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
                <Typography variant="h6" sx={{ fontWeight: 550 }}>
                  support@scheduify.com
                </Typography>
                <Stack direction="row" spacing={1.5}>
                  <Button
                    sx={{ flex: 1 }}
                    variant="contained"
                    color="primary"
                    startIcon={<EmailOutlined />}
                    component="a"
                    href="mailto:support@scheduify.com"
                  >
                    Email support
                  </Button>
                </Stack>
              </CardContent>
            </Card>
        </Stack>
      </Box>
    </Container>
  );
};

export default ContactSupportPage;
